function clearSelection(document) {
  if (document.getSelection) {
    if (document.getSelection().empty) {
      // Chrome
      document.getSelection().empty();
    } else if (document.getSelection().removeAllRanges) {
      // Firefox
      document.getSelection().removeAllRanges();
    }
  } else if (document.selection) {
    // IE?
    document.selection.empty();
  }
}

export { clearSelection };
